import React from 'react';
import PropTypes from 'prop-types';

function PillButton({ children, onClick, className = '', ...props }) {
  const buttonClasses = `btn-pill ${className}`.trim();
  return (
    <button
      className={buttonClasses}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
}

PillButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default PillButton;